/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { CoverageCoverageIsochronesGet200Response } from '@/client/models';
/**
 * IsochronesApi - axios parameter creator
 */
export const IsochronesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate isochrones (Beta)
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} from 
         * @param {number} [maxDuration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageIsochronesGet: async (coverage: string, from: string, maxDuration?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageIsochronesGet', 'coverage', coverage)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('coverageCoverageIsochronesGet', 'from', from)
            const localVarPath = `/coverage/{coverage}/isochrones`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (maxDuration !== undefined) {
                localVarQueryParameter['max_duration'] = maxDuration;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IsochronesApi - functional programming interface
 */
export const IsochronesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IsochronesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate isochrones (Beta)
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} from 
         * @param {number} [maxDuration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageIsochronesGet(coverage: string, from: string, maxDuration?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageCoverageIsochronesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageIsochronesGet(coverage, from, maxDuration, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IsochronesApi.coverageCoverageIsochronesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IsochronesApi - factory interface
 */
export const IsochronesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IsochronesApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate isochrones (Beta)
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} from 
         * @param {number} [maxDuration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageIsochronesGet(coverage: string, from: string, maxDuration?: number, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageIsochronesGet200Response> {
            return localVarFp.coverageCoverageIsochronesGet(coverage, from, maxDuration, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IsochronesApi - interface
 */
export interface IsochronesApiInterface {
    /**
     * 
     * @summary Calculate isochrones (Beta)
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} from 
     * @param {number} [maxDuration] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageIsochronesGet(coverage: string, from: string, maxDuration?: number, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageIsochronesGet200Response>;

}

/**
 * IsochronesApi - object-oriented interface
 */
export class IsochronesApi extends BaseAPI implements IsochronesApiInterface {
    /**
     * 
     * @summary Calculate isochrones (Beta)
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} from 
     * @param {number} [maxDuration] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageIsochronesGet(coverage: string, from: string, maxDuration?: number, options?: RawAxiosRequestConfig) {
        return IsochronesApiFp(this.configuration).coverageCoverageIsochronesGet(coverage, from, maxDuration, options).then((request) => request(this.axios, this.basePath));
    }
}

